import React from 'react';
import styled from 'styled-components';
import {colours} from '../Styles';
import { icons } from '../img/Icons';
import LogoEditor from './SvgIcon';
import Btn from './Btn';

function ShowcaseContent() {
    const {light} = colours;
    const { pdLogo } = icons;
    const ShowcaseContent = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: ${light};
    z-index: 1;
    h1 {
        font-size: 40px;
    }
    hr {
        width: 300px;
    }
    #showcaseBtns {
    margin-top: 20px;
    }
    @media only screen and (min-width: 600px) {
        margin-top: 180px;
    }
    `;
    return (
        <ShowcaseContent>
                <LogoEditor width="100px" fill={light} icon={pdLogo}/>
                <h1>PRECISION DETAIL</h1>
                <hr></hr>
                <h4>Mobile automotive detailing</h4>
                <div id="showcaseBtns">
                    <Btn text='BOOK' address="/book"/>
                    <Btn text='MORE INFO' address="/services"/>
                </div>
        </ShowcaseContent>
    )
}

export default ShowcaseContent;